<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('settings.users')" v-show="!$route.params.id" :showSearch="true" @search="searchUser">
            <template v-slot:commands>
                <button type="button" style="margin-left: 10px;" class="btn btn-success " @click="$router.push({ name: 'UserImport' })">
                    {{translate('externalSignerImport.importFromExcel2')}}
                </button>
                <excel-exporter table-id="userExport" :columns="columns" url="/user/get" modelName="User"  orderBy="LastName, FirstName" :predicate="'IsServiceUser != true'"></excel-exporter>
                <button type="button" class="btn btn-primary" @click="$router.push({ name: 'UserDetail',  params: { id: '000000000000000000000000' }, })">
                    {{translate('userIdentity.newUser')}}
                </button>
            </template>
            <list ref="userList" :columns="columns" url="/user/get" modelName="User" :predicate="predicate" orderBy="IsActive desc,LastName, FirstName"> </list>
            <user-import v-if="showModal" @onsave="setImportResult" @close="closeImportModal"> </user-import>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from "../components/List.vue";
import listContainer from "../components/ListContainer.vue";
import userImport from "../components/UserImport.vue";
import ExcelExporter from '../components/ExcelExporter.vue';
import Vue from "vue";


export default {
    data() {
        var isSupportExternalUsers = this.isSupportExternalUsers();
        var authsDefinitions = [];

        this.getAuthorizationDefinitions()
            .then(x => {
                authsDefinitions = x;
            }).catch(x => {
                console.log('ExcelExport için kullanıcı yetki tanımları yüklenemedi.', x);
            })

        return {
            searchText: "",
            predicate: "IsServiceUser != true",
            showModal: false,
            userList: [],
            isAllUsers : false,
            columns: [
                {
                    Key: "ProfilePictureUrl",
                    Title: "",
                    HideIfExport:true,
                    Style: "width:1px; ",
                },
                {
                    Key: "FirstName",
                    Title: this.translate('externalSigner.name'),
                    SortField: "FirstName",
                },
                {
                    Key: "LastName",
                    Title: this.translate('externalSigner.surname'),
                    SortField: "LastName",
                },
                {
                    Key: "Title.Name",
                    Title: this.translate('approvalAuthorityEditorUser.title'),
                    Content(i) {
                        return i.Title?.Name;
                    },
                },
                {
                    Key: "Department.Name",
                    Title: this.translate('approvalAuthorityEditorUser.department'),
                    Content(i) {
                        if(i.Departments)
                            return i.Departments.map(x => x.Name.cleanHtml()).join(', ');
                        return '';
                    },
                },
                {
                    Key: "Email",
                    Title: this.translate('approvalAuthorityEditorUser.email'),
                    SortField: "Email",
                },
                {
                    Key: "IsExternalUser",
                    Title: this.translate('userIdentity.isExternalUser'),
                    SortField: "IsExternalUser",
                    IsVisible: function(){
                        return isSupportExternalUsers;
                    },
                    Class: "text-center", 
                    Content(i) {
                        return Vue.filter("checkicon")(i.IsExternalUser);
                    },
                },
                {
                    Key: "ExternalIdentitySource",
                    Title: this.translate('userIdentity.externalUserSource'),
                    SortField: "ExternalIdentitySource",
                    IsVisible: function(){
                        return isSupportExternalUsers;
                    },
                    Class: "text-center", 
                    Content(i) {
                        return i.ExternalIdentitySource;
                    },
                },
                {
                    Key: "IsActive",
                    Title: this.translate('targetSystemImport.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                //   Style: "width:100px",
                    Content(i) {
                        return Vue.filter("checkicon")(i.IsActive);
                    },
                },
                {
                    Key: "Authorities",
                    Title: this.translate('userIdentity.auths'),
                    ExportOnly: true,
                    Content(i) {
                        if(i.Authorities)
                        {                                    
                            if(authsDefinitions)      
                            {
                                return i.Authorities.map(function(x)
                                {
                                    var item = authsDefinitions.find(y => y.Value == x);
                                    if(item)
                                        return item.Name.cleanHtml();
                                    else
                                        return x.cleanHtml();
                                }).join(', ');
                            }
                            else
                                return i.Authorities.map(x => x.cleanHtml()).join(', ');
                        }

                        return '';
                    },
                },
            ],
        };
    },
    components: {
        list,ExcelExporter,
        listContainer,
        userImport,
    },
    methods:{ 
        searchUser(text) {
            // var parts = [];
            // console.log(text);
            
            // if(text != "")
            //     parts.push(`FirstName.ToLower().Contains("${text.toLowerCase()}") || LastName.ToLower().Contains("${text.toLowerCase()}")`);

            // this.predicate = parts.join(" && "); 
            // this.$refs.userList.predicate = this.predicate;
            // this.$refs.userList.getData();

            this.$refs.userList.page = 1;
            this.$refs.userList.filter = { search: text };
            this.$refs.userList.getData();
        },
        setImportResult(users) {
            console.log(users);
            if (this.userList == null || this.userList == undefined) {
                this.userList = [];
            } else {
                this.userList = users;
            }
        },
        closeImportModal() {
            this.showModal = false;
            this.userList = [];
        },
    }
            
};
</script>
<style scoped>
    .col-search {
        margin-top: 20px;
        float: right;
        clear: both;
        width: 39%;
    }
    .mbm {
        margin-bottom: 10px !important;
    }
    .input-group-btn {
        padding-left: 10px;
        padding-top: 6px;
        padding-right: 10px;
        background-color: #e5e5e5;
        color: #777777;
        border-color: #e5e5e5;
        border: 1px solid #e5e5e5;
        position: relative;
        font-size: 0;
        white-space: nowrap;
    }
</style>
